import Vue from 'vue'
import App from './App.vue'
import Err from './Err.vue'
import './plugins/axios'
import './plugins/marked'
import './plugins/filters'
import vuetify from './plugins/vuetify';
import store from './plugins/store'
import config from './config'

Vue.config.productionTip = false

config.mount(Vue.prototype)
    .then(() => {
        new Vue({
            vuetify,
            store,
            render: h => h(App)
        }).$mount('#app')
    })
    .catch(err => {
        Vue.prototype.currentError = err
        new Vue({
            store,
            vuetify,
            render: h => h(Err)
        }).$mount('#app')
    })
